import { Link, type Props as LinkProps } from '@/components/Link/Link';

import { BaseButton, type ChildRenderProps, type ExtendedProps } from './BaseButton';
import { ButtonSize, ButtonVariant } from './types';

export function ButtonLink({
    active,
    block = false,
    children,
    centered = block,
    className,
    disabled,
    href,
    iconClassName,
    iconLeft,
    iconRight,
    size = 'medium',
    variant = 'secondary',
    labelClassName,
    ...props
}: ButtonLink.Props) {
    function renderLink({
        children: renderChildren,
        disabled: internalDisabled,
        'data-has-text-content': hasTextContent,
        ...attributes
    }: ChildRenderProps) {
        const ariaLabel = props['aria-label'];

        return (
            <Link
                {...props}
                aria-disabled={internalDisabled}
                aria-label={ariaLabel}
                href={internalDisabled ? '' : href}
                {...attributes}
            >
                {renderChildren}
            </Link>
        );
    }

    return (
        <BaseButton
            active={active ?? false}
            aria-disabled={disabled}
            block={block}
            centered={centered}
            className={className}
            disabled={disabled ?? false}
            iconClassName={iconClassName}
            iconLeft={iconLeft}
            iconRight={iconRight}
            render={renderLink}
            size={size}
            variant={variant}
            labelClassName={labelClassName}
        >
            {children}
        </BaseButton>
    );
}

export namespace ButtonLink {
    export type Props = ExtendedProps<LinkProps>;
    export type Variant = ButtonVariant;
    export const Variant = ButtonVariant;

    export type Size = ButtonSize;
    export const Size = ButtonSize;
}
